module.exports = __webpack_public_path__ + "static/img/strategy-right.9492ed66.png";